import { FC, PropsWithChildren, MouseEvent, ReactNode, useRef, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './index.less';

type Placement = 'top' | 'bottom';

type Position = {
  right?: number;
  left?: number;
  top?: number;
  bottom?: number;
}

interface MenuItemOption {
  key: UKey;
  title: ReactNode;
}

export interface DropdownMenuProps {
  options: MenuItemOption[];
  onSelect: (key: UKey) => void;
}

const DropdownMenu: FC<PropsWithChildren<DropdownMenuProps>> = ({
  children,
  options = [],
  onSelect
}) => {
  const dropdownRef = useRef<HTMLDivElement>();
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState<Position>({ right: 10000, top: 10000 });
  const [placement, setPlacement] = useState<Placement>('bottom');

  const handleTrigger = useCallback((e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    const triggerRect = (e?.target as HTMLSpanElement).getBoundingClientRect();
    console.log('triggerRect:', (e?.target as HTMLSpanElement).getBoundingClientRect());
    if (dropdownRef.current) {
      const dropdownRect = dropdownRef.current?.getBoundingClientRect();
      console.log('dropdownRect:', dropdownRect);
      const placement = window.innerHeight - triggerRect.y - triggerRect.height - dropdownRect.height > 20 ? 'bottom' : 'top';
      setPlacement(placement);
      setPosition({
        right: window.innerWidth - triggerRect.x - (triggerRect.width / 2) - 10 - 5, // 加上箭头离弹框边的距离和箭头宽度的一半
        top: ({
          top: triggerRect.y - dropdownRect.height,
          bottom: triggerRect.y + triggerRect.height
        }[placement])
      });
    }
    setVisible(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const handleClose = (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    setVisible(false);
  }

  return (
    <>
      <span className={styles.triggerWrapper} onClick={handleTrigger}>
        {children}
      </span>
      {ReactDOM.createPortal((
        <div className={classNames(styles.wrapper, { [styles.visible]: visible })} onClick={handleClose}>
          <div ref={dropdownRef} className={classNames(styles.dropdown, styles[placement])} style={position}>
            <ul className={styles.menu}>
              {options.map(({ key, title }) => (
                <li key={key} className={styles.item} onClick={() => onSelect(key)}>{title}</li>
              ))}
            </ul>
          </div>
        </div>
      ), document.body)}
    </>
  )
}

export default DropdownMenu;
